<template>
  <form>
    <div class="columns">
      <div class="column field is-8">
        <label class="label">Name</label>
        <div class="control">
          <validation-provider v-slot="errors" rules="required">
            <input
              v-model="model.name"
              class="input"
              type="text"
              :disabled="!editing"
            />
            <span class="help">{{ errors.errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column field is-8">
        <label class="label">
          <template v-if="isWorkgroup">Parent division</template>
          <template v-else>Parent organization</template>
        </label>
        <div class="control">
          <validation-provider v-slot="errors" rules="required">
            <div class="select">
              <select
                v-if="isWorkgroup"
                v-model="model.parentGroupID"
                :disabled="!editing"
              >
                <option
                  v-for="r in $store.getters['groups/divisions']"
                  :key="r.groupID"
                  :value="r.groupID"
                  :disabled="r.disabled"
                  v-html="r.name"
                ></option>
              </select>
              <select v-else v-model="model.parentGroupID" :disabled="!editing">
                <option
                  v-for="r in $store.getters['groups/organizations']"
                  :key="r.groupID"
                  :value="r.groupID"
                  :disabled="r.disabled"
                  v-html="r.name"
                ></option>
              </select>
            </div>
            <span class="help">{{ errors.errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>
    <!-- <input type="hidden" v-model="model.parentGroupID" v-else :value=""> -->
  </form>
</template>

<script>
// import _ from 'lodash';
import Form from './Form.js';

export default {
  name: 'GroupForm',
  extends: Form,
  props: {
    isWorkgroup: { type: Boolean, default: false }
  },
  data() {
    return {
      model: {}
    };
  }
};
</script>
